export default function NotFound() {
    return <h1>404 Page Not Found / 페이지를 찾을 수 없습니다.</h1>
}